import React from 'react';

import {CheckOutStatus} from 'constants/SampleStatusConstants';
import {MultiValueFilter} from 'search/SearchConstants';
import {OptionData} from 'ui-library/menus/MenuConstants';
import {capitalize, constantCaseToWords} from 'util/NameUtil';

import DropdownFilterForm, {prefixedToggleText} from './base/DropdownFilterForm';
import {BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

export interface Props extends BaseFilterFormProps {
  filter: MultiValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: MultiValueFilter) => void;
  onRemove?: () => void;
}

export default function ContainerCheckOutStatusFilterForm(props: Props): JSX.Element {
  // eslint-disable-next-line no-restricted-syntax
  const optionDatas: Array<OptionData> = Object.values(CheckOutStatus)
    .sort()
    .map((value) => ({
      name: capitalize(constantCaseToWords(value)),
      value,
    }));
  return (
    <DropdownFilterForm
      {...props}
      dropdownToggleText={prefixedToggleText('Status', optionDatas, props.filter)}
      filterStyle={props.filterStyle}
      isMulti={true}
      onChangeValue={(value: Array<string>) => {
        props.onChangeFilter({...props.filter, value});
      }}
      onRemove={props.onRemove}
      optionDatas={optionDatas}
      value={props.filter.value}
    />
  );
}
